import { render, staticRenderFns } from "./DataTypeSelect.vue?vue&type=template&id=8ccacc74&scoped=true&"
import script from "./DataTypeSelect.vue?vue&type=script&lang=js&"
export * from "./DataTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccacc74",
  null
  
)

export default component.exports